export function normalizeOpenPanelApiUrl(raw: string | undefined | null): string {
  if (!raw) {
    return '';
  }
  const t = raw.trim().replace(/\/+$/, '');
  if (!t) {
    return '';
  }
  return t;
}
